var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 0H8.75L14 5.4V16.2C14 16.6774 13.8156 17.1352 13.4874 17.4728C13.1592 17.8104 12.7141 18 12.25 18H1.75C1.28587 18 0.840752 17.8104 0.512563 17.4728C0.184374 17.1352 0 16.6774 0 16.2V1.8C0 1.32261 0.184374 0.864773 0.512563 0.527208C0.840752 0.189642 1.28587 0 1.75 0ZM7.875 1.79999V6.29999H12.25L7.875 1.79999Z",
    fill: "#30323A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.e1eadd310c44a00ab61a579add691452.svg";
export { ForwardRef as ReactComponent };